export default [
  {
    path: '/login',
    component: () => import('@/views/servidor/login/index'),
    meta: {
      body: 'bg-light',
    },
    children: [
      {
        path: '',
        name: 'login',
        component: () => import('@/views/servidor/login/login'),
      },
      {
        path: 'password_confirmation',
        name: 'password-confirmation',
        component: () => import('@/views/servidor/login/password-confirmation'),
      },
      {
        path: 'password-forgot',
        name: 'password-forgot',
        component: () => import('@/views/servidor/login/password-forgot'),
      },
    ],
  },
]
